
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { Metamodel } from 'app/model/base/model';
import { AzureDataLakeStoreFileDataset } from 'app/model/dataset/azure-data-lake-store.dataset';
import { AzureDataLakeStoreLinkedService } from 'app/model/linkedservice/azure-data-lake-store.linkedservice';
import { maxConcurrentConnectionsMetadata, recursiveCheckboxMetadata, copyBehaviorMetadata } from '../consts/metadata-consts';

export const azureDataLakeStoreFileDatasetMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(AzureDataLakeStoreFileDataset).name,
    supportLinkedServiceTypes: [Metamodel.modelFor(AzureDataLakeStoreLinkedService).name],
    displayName: stringResources.AzureDataLakeStore_DisplayText,
    datasetKind: 'file',
    isSource: true,
    isSink: true,
    icon: {
        className: 'svg-i-100x100-AzureDataLake'
    },
    isFirstClass: true,
    category: ['Azure'],
    supportIncrementalBinaryCopy: true,
    supportGetMetadataActivity: true,
    supportRootFolder: true,
    supportDeleteActivity: true,
    copySourceControls: [
        recursiveCheckboxMetadata,
        maxConcurrentConnectionsMetadata
    ],
    copySinkControls: [
        copyBehaviorMetadata,
        maxConcurrentConnectionsMetadata
    ]
};
